/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { __decorate } from "tslib";
import { customElement } from 'lit/decorators.js';
import { styles as forcedColorsStyles } from './lib/forced-colors-styles.css.js';
import { Radio } from './lib/radio.js';
import { styles } from './lib/radio-styles.css.js';
/**
 * @summary Radio buttons allow users to select one option from a set.
 *
 * @description
 * Radio buttons are the recommended way to allow users to make a single
 * selection from a list of options.
 *
 * Only one radio button can be selected at a time.
 *
 * Use radio buttons to:
 * - Select a single option from a set
 * - Expose all available options
 *
 * @final
 * @suppress {visibility}
 */
let MdRadio = class MdRadio extends Radio {
};
MdRadio.styles = [styles, forcedColorsStyles];
MdRadio = __decorate([
    customElement('md-radio')
], MdRadio);
export { MdRadio };
//# sourceMappingURL=radio.js.map